import React from 'react';
import { motion } from 'framer-motion';
import { usePageMeta } from '../hooks/usePageMeta';
import { Section } from '../components/ui/Section';
import { useIsKenya, getPhoneDisplay } from '../hooks/useIsKenya';
function HeroArtwork() {
  return <motion.svg viewBox="0 0 400 300" className="w-full h-full max-h-[280px]" initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.8,
    delay: 0.2
  }} data-id="element-1028">
      {/* Large circle - stroke only */}
      <circle cx="200" cy="150" r="120" fill="none" stroke="#FF6600" strokeWidth="1" opacity="0.12" data-id="element-1029" />
      <circle cx="200" cy="150" r="80" fill="none" stroke="#FF6600" strokeWidth="0.5" opacity="0.1" data-id="element-1030" />
      <circle cx="200" cy="150" r="40" fill="#FF6600" opacity="0.04" data-id="element-1031" />

      {/* Arc segments */}
      <path d="M 80 150 A 120 120 0 0 1 200 30" fill="none" stroke="#FF6600" strokeWidth="2" opacity="0.15" data-id="element-1032" />
      <path d="M 320 150 A 120 120 0 0 1 200 270" fill="none" stroke="#FF6600" strokeWidth="2" opacity="0.15" data-id="element-1033" />

      {/* Grid lines */}
      <line x1="50" y1="150" x2="350" y2="150" stroke="#FF6600" strokeWidth="0.5" opacity="0.08" data-id="element-1034" />
      <line x1="200" y1="20" x2="200" y2="280" stroke="#FF6600" strokeWidth="0.5" opacity="0.08" data-id="element-1035" />

      {/* Diagonal lines */}
      <line x1="80" y1="50" x2="320" y2="250" stroke="#FF6600" strokeWidth="0.5" opacity="0.06" data-id="element-1036" />
      <line x1="320" y1="50" x2="80" y2="250" stroke="#FF6600" strokeWidth="0.5" opacity="0.06" data-id="element-1037" />

      {/* Scattered dots */}
      <circle cx="120" cy="80" r="3" fill="#FF6600" opacity="0.18" data-id="element-1038" />
      <circle cx="280" cy="220" r="3" fill="#FF6600" opacity="0.18" data-id="element-1039" />
      <circle cx="300" cy="80" r="2" fill="#FF6600" opacity="0.12" data-id="element-1040" />
      <circle cx="100" cy="200" r="2" fill="#FF6600" opacity="0.12" data-id="element-1041" />
      <circle cx="200" cy="150" r="4" fill="#FF6600" opacity="0.2" data-id="element-1042" />

      {/* Small accent circles */}
      <circle cx="140" cy="120" r="15" fill="none" stroke="#FF6600" strokeWidth="1" opacity="0.1" data-id="element-1043" />
      <circle cx="260" cy="180" r="15" fill="none" stroke="#FF6600" strokeWidth="1" opacity="0.1" data-id="element-1044" />

      {/* Blue accent - subtle */}
      <circle cx="240" cy="100" r="6" fill="#00316B" opacity="0.12" data-id="element-1045" />
    </motion.svg>;
}
function SidebarArtwork() {
  return <motion.svg viewBox="0 0 100 500" className="w-full h-auto" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.6,
    delay: 0.4
  }} data-id="element-1046">
      {/* Vertical line */}
      <line x1="50" y1="0" x2="50" y2="500" stroke="#FF6600" strokeWidth="0.5" opacity="0.08" data-id="element-1047" />

      {/* Stacked circles */}
      <circle cx="50" cy="60" r="40" fill="none" stroke="#FF6600" strokeWidth="1" opacity="0.1" data-id="element-1048" />
      <circle cx="50" cy="60" r="25" fill="none" stroke="#FF6600" strokeWidth="0.5" opacity="0.08" data-id="element-1049" />
      <circle cx="50" cy="60" r="4" fill="#FF6600" opacity="0.15" data-id="element-1050" />

      <circle cx="50" cy="180" r="30" fill="none" stroke="#FF6600" strokeWidth="1" opacity="0.1" data-id="element-1051" />
      <circle cx="50" cy="180" r="15" fill="#FF6600" opacity="0.04" data-id="element-1052" />

      <circle cx="50" cy="280" r="35" fill="none" stroke="#FF6600" strokeWidth="1" opacity="0.1" data-id="element-1053" />
      <circle cx="50" cy="280" r="20" fill="none" stroke="#FF6600" strokeWidth="0.5" opacity="0.08" data-id="element-1054" />

      <circle cx="50" cy="380" r="25" fill="none" stroke="#FF6600" strokeWidth="1" opacity="0.1" data-id="element-1055" />
      <circle cx="50" cy="380" r="3" fill="#FF6600" opacity="0.15" data-id="element-1056" />

      {/* Horizontal accent lines */}
      <line x1="20" y1="120" x2="80" y2="120" stroke="#FF6600" strokeWidth="0.5" opacity="0.1" data-id="element-1057" />
      <line x1="30" y1="230" x2="70" y2="230" stroke="#FF6600" strokeWidth="0.5" opacity="0.1" data-id="element-1058" />
      <line x1="25" y1="330" x2="75" y2="330" stroke="#FF6600" strokeWidth="0.5" opacity="0.1" data-id="element-1059" />

      {/* Small dots */}
      <circle cx="30" cy="140" r="2" fill="#FF6600" opacity="0.12" data-id="element-1060" />
      <circle cx="70" cy="260" r="2" fill="#FF6600" opacity="0.12" data-id="element-1061" />
      <circle cx="35" cy="350" r="2" fill="#FF6600" opacity="0.12" data-id="element-1062" />

      {/* Blue accent */}
      <circle cx="50" cy="450" r="20" fill="none" stroke="#00316B" strokeWidth="1" opacity="0.1" data-id="element-1063" />
      <circle cx="50" cy="450" r="3" fill="#00316B" opacity="0.15" data-id="element-1064" />
    </motion.svg>;
}
export function TermsPage() {
  usePageMeta({
    title: 'Terms of Use',
    description: "Read the terms and conditions for using Belo Digital's website and services."
  });
  const isKenya = useIsKenya();
  const phoneDisplay = getPhoneDisplay(isKenya);
  const sections = [{
    number: '1',
    title: 'Introduction',
    content: <p data-id="element-1065">
          Welcome to Belo Digital. By accessing or using our website, products,
          or services, you agree to be bound by these Terms & Conditions. If you
          do not agree, please refrain from using our services.
        </p>
  }, {
    number: '2',
    title: 'Services',
    content: <>
          <p className="mb-4" data-id="element-1066">
            Belo Digital provides digital solutions including but not limited
            to:
          </p>
          <ul className="space-y-3" data-id="element-1067">
            <li className="flex items-start text-lg" data-id="element-1068">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1069" />
              Software & digital systems development
            </li>
            <li className="flex items-start text-lg" data-id="element-1070">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1071" />
              IT consulting & advisory
            </li>
            <li className="flex items-start text-lg" data-id="element-1072">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1073" />
              Digital infrastructure & integrations
            </li>
            <li className="flex items-start text-lg" data-id="element-1074">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1075" />
              Data & technology solutions
            </li>
          </ul>
          <p className="mt-4" data-id="element-1076">
            Specific service details may be governed by separate agreements or
            contracts.
          </p>
        </>
  }, {
    number: '3',
    title: 'Use of Website',
    content: <>
          <p className="mb-4" data-id="element-1077">
            You agree to use our website lawfully and not to:
          </p>
          <ul className="space-y-3" data-id="element-1078">
            <li className="flex items-start text-lg" data-id="element-1079">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1080" />
              Engage in fraudulent or harmful activities
            </li>
            <li className="flex items-start text-lg" data-id="element-1081">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1082" />
              Attempt unauthorized access to systems
            </li>
            <li className="flex items-start text-lg" data-id="element-1083">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1084" />
              Distribute malicious software or code
            </li>
            <li className="flex items-start text-lg" data-id="element-1085">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1086" />
              Violate applicable laws or regulations
            </li>
          </ul>
        </>
  }, {
    number: '4',
    title: 'Intellectual Property',
    content: <p data-id="element-1087">
          All content, designs, software, trademarks, and materials on this
          website belong to Belo Digital unless stated otherwise. Unauthorized
          reproduction or use is prohibited.
        </p>
  }, {
    number: '5',
    title: 'Client Responsibilities',
    content: <>
          <p className="mb-4" data-id="element-1088">Clients agree to:</p>
          <ul className="space-y-3" data-id="element-1089">
            <li className="flex items-start text-lg" data-id="element-1090">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1091" />
              Provide accurate and lawful information
            </li>
            <li className="flex items-start text-lg" data-id="element-1092">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1093" />
              Maintain confidentiality of credentials
            </li>
            <li className="flex items-start text-lg" data-id="element-1094">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1095" />
              Use delivered solutions responsibly
            </li>
            <li className="flex items-start text-lg" data-id="element-1096">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1097" />
              Comply with applicable laws
            </li>
          </ul>
        </>
  }, {
    number: '6',
    title: 'Limitation of Liability',
    content: <p data-id="element-1098">
          Belo Digital shall not be liable for indirect, incidental, or
          consequential damages arising from use of our website or services,
          except where required by law.
        </p>
  }, {
    number: '7',
    title: 'Confidentiality',
    content: <p data-id="element-1099">
          We respect confidentiality of client information. Both parties may be
          bound by separate Non-Disclosure Agreements where applicable.
        </p>
  }, {
    number: '8',
    title: 'Termination',
    content: <p data-id="element-1100">
          We reserve the right to suspend or terminate access to services where
          misuse, unlawful activity, or breach of terms occurs.
        </p>
  }, {
    number: '9',
    title: 'Governing Law',
    content: <p data-id="element-1101">These Terms are governed by the laws of the Republic of Kenya.</p>
  }, {
    number: '10',
    title: 'Changes to Terms',
    content: <p data-id="element-1102">
          We may update these Terms from time to time. Continued use of services
          constitutes acceptance of revised Terms.
        </p>
  }, {
    number: '11',
    title: 'Contact Information',
    content: <div className="space-y-2" data-id="element-1103">
          <p data-id="element-1104">For questions regarding these Terms:</p>
          <p className="font-semibold text-[#0C0C0C]" data-id="element-1105">Belo Digital</p>
          <p data-id="element-1106">
            Email:{' '}
            <a href="mailto:biz@belo.co.ke" className="text-[#00316B] hover:text-[#FF6600] transition-colors" data-id="element-1107">
              biz@belo.co.ke
            </a>
          </p>
          <p data-id="element-1108">
            Phone:{' '}
            <a href="tel:+254701660306" className="text-[#00316B] hover:text-[#FF6600] transition-colors" data-id="element-1109">
              {phoneDisplay}
            </a>
          </p>
        </div>
  }];
  return <main className="pt-24" data-id="element-1110">
      <Section background="default" data-id="element-1111">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1112">
          <div data-id="element-1113">
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-sm font-semibold text-[#FF6600] uppercase tracking-wider mb-4" data-id="element-1114">
              Legal
            </motion.p>
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.05
          }} className="text-4xl md:text-5xl font-bold font-heading text-[#0C0C0C] mb-4 leading-tight" data-id="element-1115">
              Terms & Conditions
            </motion.h1>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="text-gray-500 text-base" data-id="element-1116">
              Last updated:{' '}
              {new Date().toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            })}
            </motion.p>
          </div>
          <div className="hidden lg:flex items-center justify-center" data-id="element-1117">
            <HeroArtwork data-id="element-1118" />
          </div>
        </div>
      </Section>

      <Section background="white" data-id="element-1119">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-1120">
          {/* Main content */}
          <div className="lg:col-span-9" data-id="element-1121">
            <div className="space-y-14" data-id="element-1122">
              {sections.map((section, index) => <motion.div key={section.number} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.04
            }} className="border-b border-gray-100 pb-14 last:border-0" data-id="element-1123">
                  <div className="flex items-start gap-4 mb-5" data-id="element-1124">
                    <span className="text-sm font-bold text-[#FF6600] bg-[#FF6600]/10 px-3 py-1.5 rounded mt-0.5 shrink-0" data-id="element-1125">
                      {section.number.padStart(2, '0')}
                    </span>
                    <h2 className="text-2xl font-bold font-heading text-[#0C0C0C]" data-id="element-1126">
                      {section.title}
                    </h2>
                  </div>
                  <div className="ml-14 text-gray-600 leading-relaxed text-lg" data-id="element-1127">
                    {section.content}
                  </div>
                </motion.div>)}
            </div>
          </div>

          {/* Decorative sidebar */}
          <div className="hidden lg:block lg:col-span-3" data-id="element-1128">
            <div className="sticky top-32" data-id="element-1129">
              <SidebarArtwork data-id="element-1130" />
            </div>
          </div>
        </div>
      </Section>
    </main>;
}